/**
 * @generated SignedSource<<454f829806d2962ae35668d4ce7ec6d9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SessionStatus = "ACTIVE" | "DEBRIEFED" | "DEBRIEFING" | "ENDED" | "FAILED" | "%future added value";
export type SessionProviderEndSessionMutation$variables = {
  sessionId: string;
};
export type SessionProviderEndSessionMutation$data = {
  readonly endSession: {
    readonly session: {
      readonly id: string;
      readonly status: SessionStatus;
    };
  };
};
export type SessionProviderEndSessionMutation = {
  response: SessionProviderEndSessionMutation$data;
  variables: SessionProviderEndSessionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sessionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "sessionId",
        "variableName": "sessionId"
      }
    ],
    "concreteType": "EndSessionPayload",
    "kind": "LinkedField",
    "name": "endSession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SessionProviderEndSessionMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "SessionProviderEndSessionMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "899fb9363b733b8ac36dab3d694cca81",
    "id": null,
    "metadata": {},
    "name": "SessionProviderEndSessionMutation",
    "operationKind": "mutation",
    "text": "mutation SessionProviderEndSessionMutation(\n  $sessionId: ID!\n) {\n  endSession(sessionId: $sessionId) {\n    session {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "74b3a8bdeb1fa60a9ebb7518d3449b1b";

export default node;
